import { render, staticRenderFns } from "./WShipmentStatus.vue?vue&type=template&id=ec60c6c2&"
import script from "./WShipmentStatus.vue?vue&type=script&lang=js&"
export * from "./WShipmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports